import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { API_URL } from '../config/apiConfig';
import { FaEnvelope, FaSpinner, FaCheckCircle } from 'react-icons/fa';
import './NewsletterSignup.css';

const NewsletterSignup = ({ 
  title = "Subscribe to Our Newsletter", 
  subtitle = "Get the latest travel tips and transportation insights delivered to your inbox.",
  showHeader = true,
  darkMode = false
}) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `${API_URL}/newsletter/subscribe`,
        { email }
      );

      if (response.data.success) {
        setSubscribed(true);
        setEmail('');
        toast.success('Successfully subscribed to newsletter!');

        // Reset after 3 seconds
        setTimeout(() => {
          setSubscribed(false);
        }, 3000);
      }
    } catch (error) {
      console.error('Error subscribing:', error);
      const message = error.response?.data?.message || 'Failed to subscribe. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <div className={`newsletter-section ${darkMode ? 'dark-mode' : ''}`}>
        <div className="newsletter-content">
          <div className="success-message">
            <FaCheckCircle className="success-icon" />
            <h2>Thank You!</h2>
            <p>Check your email for confirmation and exclusive offers.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`newsletter-section ${darkMode ? 'dark-mode' : ''} ${!showHeader ? 'no-header' : ''}`}>
      <div className="newsletter-content">
        {showHeader && (
          <>
            <h2 className="newsletter-title">{title}</h2>
            <p className="newsletter-subtitle">{subtitle}</p>
          </>
        )}

        <form onSubmit={handleSubscribe} className="newsletter-form">
          <div className="newsletter-input-wrapper">
            <FaEnvelope className="newsletter-icon" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="newsletter-input"
              disabled={loading}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="newsletter-button"
          >
            {loading ? (
              <>
                <FaSpinner className="spinner" />
                Subscribing...
              </>
            ) : (
              'Subscribe'
            )}
          </button>
        </form>

        {showHeader && (
          <p className="newsletter-notice">
            We respect your privacy. Unsubscribe at any time.
          </p>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup;
